import i18n from '@/i18n';
import http from '../services/http';

const sampleProgress = {
  findSteps(sampleId, { lang = i18n.locale } = {}) {
    return http.request({
      method: 'get',
      url: `/samples/${sampleId}/progress/steps`,
      params: { lang },
    });
  },
  /**
   * Without stepId it returns the snapshot of every step at once, so switching step needs no
   * further call. lang is explicit because the backend otherwise prefers the language stored
   * on the user over the one active in the UI.
   */
  findDomainMeta(sampleId, { stepId, lang = i18n.locale } = {}) {
    return http.request({
      method: 'get',
      url: `/samples/${sampleId}/progress/domain-meta`,
      params: { stepId, lang },
    });
  },
  /**
   * Newest first, one page at a time: { events, nextCursor }. Pass the nextCursor of the previous
   * page back as is, with the same stepId, to load the earlier ones; it is null once none is
   * left. The backend rejects half a cursor. Without stepId, every step of the sample.
   */
  findTimeline(sampleId, { stepId, cursor, lang = i18n.locale } = {}) {
    return http.request({
      method: 'get',
      url: `/samples/${sampleId}/progress/timeline`,
      params: {
        stepId,
        lang,
        ...(cursor && { beforeOccurredAt: cursor.occurredAt, beforeEventId: cursor.eventId }),
      },
    });
  },
  findFiles(sampleId) {
    return http.request({
      method: 'get',
      url: `/samples/${sampleId}/progress/files`,
    });
  },
  findChainRevisions(sampleId, chainId) {
    return http.request({
      method: 'get',
      url: `/samples/${sampleId}/progress/chains/${chainId}/revisions`,
    });
  },
  /**
   * Only the current revision of a chain: the backend refuses a superseded one. Always MyLab's
   * own copy (fileId): the fileUrl of a row is never used by the portal.
   */
  downloadFile(sampleId, attachmentId) {
    return http.request({
      method: 'get',
      url: `/samples/${sampleId}/progress/files/${attachmentId}/download`,
      responseType: 'blob',
    });
  },
};

export default sampleProgress;
